import * as React from 'react';
import { ContainerFooter } from './styles';

import { useContext, useEffect } from 'react';
import imageContext from '../../Context/ImagesContext';

const SubFooter: React.FC = () => {
 const { images, alterarLogo } = useContext(imageContext);    
    useEffect(() => {
        const logoPath = localStorage.getItem('logoPath'); 
        if (logoPath) {
          alterarLogo(logoPath); 
        }
      }, []);
      
    return (
        <ContainerFooter>

            <div className='imgSubFooter'>
                <img src={images.Logo} alt="Logo" />
            </div>

            <div className='textoFooter'>
                {/* <p>Todos os direitos reservados. CNPJ 91.973.313/0001-81 - VITROLA EDITORA E DISTRIBUIDORA LTDA | Rua Das Camelias, 321, Aparecida -Frederico Westphalen - RS</p> */}
                <p>Todos os direitos reservados. CNPJ 00.829.816/0001-22 - Partner Sistemas </p>
                <p>Avenida Cristóvão Colombo, 2948 - Sala 801 - Floresta, Porto Alegre - RS</p>
            </div>

        </ContainerFooter>
    )
};

export default SubFooter;
